module.exports = __webpack_public_path__ + "static/media/Aug_2025_3.83ae3c98.webp";